// The full ledger is rebuilt only when the state changes, not on every call. Callers
// always get a fresh array, so sorting or filtering one never reaches the cache.
const runtimeLedgerVouchers = () => cachedDerivedModel('ledgerVouchers', () => deriveAccountingLedgerVouchers(mergedRuntimeState()));
const getVouchersModel = (options = {}) => {
  window.PlummeJournalDemand.request();
  if (!runtime.appState || (!runtime.configured && !runtime.user)) return [];
  const year = options.year ? Number(options.year) : null;
  return window.PlummeTransactionVoucherModel.decorateAll(runtimeLedgerVouchers(), deriveVouchers(mergedRuntimeState(), { includeAnnulled: true })).filter((voucher) => {
    if (year && Number(nbToIso(voucher.date).slice(0, 4)) !== year) return false;
    return true;
  });
};
const getAccountingLedgerVouchersModel = (options = {}) => {
  window.PlummeJournalDemand.request();
  const state = mergedRuntimeState();
  const year = Number(options.year || state.activeYear) || new Date().getFullYear();
  const vouchers = runtimeLedgerVouchers();
  if (options.allYears) return vouchers.slice();
  return vouchers.filter((voucher) => Number(nbToIso(voucher.date).slice(0, 4)) === year);
};
